'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { isLikelyNativeAppShell } from '@/lib/native-shell-detect';

function createQueryClient(): QueryClient {
  const nativeShell = typeof window !== 'undefined' && isLikelyNativeAppShell();
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: nativeShell ? 120_000 : 30_000,
        gcTime: nativeShell ? 30 * 60_000 : 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: !nativeShell,
      },
    },
  });
}

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
